/* Sitewide referral + campaign capture (Option A).
   Same sessionStorage key and shape as today's byrdgang.com experience.js:
   'byrdgang-attribution' = {utm_source,utm_medium,utm_campaign,utm_content,utm_term,fbclid,gclid,ttclid,gbraid,wbraid,referralCode,lm}.
   ?lm= (Listmonk subscriber id) is also kept 30 days in localStorage 'byrdgang-lm'.
   On the first cart change it writes cart attributes (+ note "ref:<code>") via /cart/update.js.
   Product pages only, when the theme setting is on: one text/plain sendBeacon {lm, product} to the
   browse recorder, same body as today's browse.js (plan shared/plans/browse-beacon.md, T-82),
   only when Shopify's Customer Privacy API says analytics processing is allowed (T-107). */
(function(root,factory){
  const api=factory();
  if(typeof module==='object'&&module.exports)module.exports=api;
  else{root.BG_ATTRIBUTION=api;api.boot(root);}
})(typeof window==='undefined'?globalThis:window,function(){
  'use strict';
  const KEY='byrdgang-attribution',LM_KEY='byrdgang-lm',SYNC_KEY='byrdgang-attribution-synced';
  const LM_DAYS=30,DAY=864e5;
  const UTM=['utm_source','utm_medium','utm_campaign','utm_content','utm_term'];
  const CLICK=['fbclid','gclid','ttclid','gbraid','wbraid'];
  const CODE=/^[A-Za-z0-9_-]{1,80}$/;

  /* Merge URL params into an existing attribution object. Pure. */
  function capture(search,existing={}){
    const params=new URLSearchParams(search||''),out={...(existing&&typeof existing==='object'?existing:{})};
    for(const key of [...UTM,...CLICK]){const v=params.get(key);if(v)out[key]=v.slice(0,256);}
    const ref=params.get('ref')||params.get('referral_code');
    if(ref&&CODE.test(ref))out.referralCode=ref;
    const lm=params.get('lm');
    if(lm&&CODE.test(lm))out.lm=lm;
    return out;
  }
  /* 30-day Listmonk record, same key and shape as today's byrdgang.com browse.js
     ({id: lowercase uuid, exp}), so ids saved on the old site keep working. Pure. */
  const UUID=/^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;
  function lmRecord(search,stored,now=Date.now()){
    const lm=new URLSearchParams(search||'').get('lm');
    if(lm&&UUID.test(lm))return {id:lm.toLowerCase(),exp:now+LM_DAYS*DAY};
    if(stored&&typeof stored.id==='string'&&UUID.test(stored.id)&&Number(stored.exp)>now)return stored;
    return null;
  }
  /* Cart attributes + note to write, or null when the cart already has them. Pure. */
  function cartUpdate(attribution,cart){
    const a=attribution||{},current=cart?.attributes||{},attributes={storefront:'byrdgang-main'};
    if(a.referralCode)attributes.referral_code=a.referralCode;
    for(const key of UTM)if(a[key])attributes[key]=a[key];
    const changed=Object.entries(attributes).filter(([k,v])=>current[k]!==v);
    const note=String(cart?.note||'');
    let nextNote=null;
    if(a.referralCode&&!note.split(/\s+/).includes('ref:'+a.referralCode))nextNote=note.trim()?note.trim()+'\nref:'+a.referralCode:'ref:'+a.referralCode;
    if(!changed.length&&nextNote===null)return null;
    const body={attributes:Object.fromEntries(changed)};
    if(nextNote!==null)body.note=nextNote;
    return body;
  }
  /* Browse beacon body (today's shape), or null: needs a live 30-day id, a numeric product id and an https endpoint. Pure. */
  function viewBeacon(lm,productId,endpoint,now=Date.now()){
    const product=String(productId||'');
    if(!lm||!UUID.test(lm.id||'')||!(Number(lm.exp)>now)||!/^[0-9]{1,20}$/.test(product))return null;
    if(!/^https:\/\/[^\s/]+\/\S*$/.test(String(endpoint||'')))return null;
    return {url:endpoint,body:JSON.stringify({lm:lm.id.toLowerCase(),product})};
  }
  /* Consent gate (T-107): call back with Shopify's analyticsProcessingAllowed(); false when the API is missing,
     fails or does not answer in 5 s (fail closed). US visitors without a banner get true. */
  function analyticsAllowed(win,cb){
    let done=false;const finish=v=>{if(!done){done=true;cb(!!v);}};
    const ask=()=>{try{finish(win.Shopify.customerPrivacy.analyticsProcessingAllowed());}catch{finish(false);}};
    try{
      if(win.Shopify?.customerPrivacy?.analyticsProcessingAllowed)return ask();
      if(!win.Shopify?.loadFeatures)return finish(false);
      win.Shopify.loadFeatures([{name:'consent-tracking-api',version:'0.1'}],err=>err?finish(false):ask());
      win.setTimeout(()=>finish(false),5000);
    }catch{finish(false);}
  }
  const isCartWrite=url=>/\/cart\/(add|change|clear)(\.js)?(\?|$)/.test(String(url||'').replace(/^https?:\/\/[^/]+/,'').split('#')[0]);

  function boot(win){
    if(!win||win.__bgAttributionBooted)return;win.__bgAttributionBooted=true;
    const store=(s,k,v)=>{try{if(v===undefined)return JSON.parse(win[s].getItem(k)||'null');win[s].setItem(k,JSON.stringify(v));}catch{}return null;};
    let attribution=capture(win.location.search,store('sessionStorage',KEY)||{});
    const lm=lmRecord(win.location.search,store('localStorage',LM_KEY));
    if(lm){store('localStorage',LM_KEY,lm);attribution.lm=lm.id;}
    else{try{win.localStorage.removeItem(LM_KEY);}catch{}}
    // Like today: drop lm from the address bar so a shared link doesn't carry it.
    try{const url=new URL(win.location.href);if(url.searchParams.has('lm')){url.searchParams.delete('lm');win.history.replaceState(win.history.state,'',url.pathname+url.search+url.hash);}}catch{}
    store('sessionStorage',KEY,attribution);
    // Beacon on (bg-browse-view config): one view signal per product per page (the recorder de-dupes per 10 min).
    // Product page: on load. Picker (T-542): BG_ATTRIBUTION.view(id) when a polo is picked.
    let cfg=null;try{cfg=JSON.parse(win.document.getElementById('bg-browse-view')?.textContent||'null');}catch{}
    const viewed=new Set();
    const view=productId=>{
      try{
        const beacon=cfg&&viewBeacon(lm,productId,cfg.url);
        if(!beacon||viewed.has(String(productId))||!win.navigator.sendBeacon)return false;
        viewed.add(String(productId));
        analyticsAllowed(win,ok=>{if(ok)win.navigator.sendBeacon(beacon.url,new win.Blob([beacon.body],{type:'text/plain'}));});
        return true;
      }catch{return false;}
    };
    if(win.BG_ATTRIBUTION)win.BG_ATTRIBUTION.view=view;
    if(cfg&&cfg.product)view(cfg.product);
    const root=(()=>{try{return JSON.parse(win.document.getElementById('bg-theme-config').textContent).root||'/';}catch{return '/';}})().replace(/\/?$/,'/');
    const realFetch=win.fetch.bind(win);
    let running=null;
    async function sync(){
      if(running)return running;
      running=(async()=>{
        const cart=await (await realFetch(root+'cart.js',{credentials:'same-origin',cache:'no-store',headers:{Accept:'application/json'}})).json();
        if(!cart.item_count)return;
        const body=cartUpdate(attribution,cart);
        if(!body)return;
        const write=()=>realFetch(root+'cart/update.js',{method:'POST',credentials:'same-origin',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify(body)});
        const locks=win.navigator?.locks;
        await (locks?.request?locks.request('byrdgang-cart-write',write):write());
        try{win.sessionStorage.setItem(SYNC_KEY,'1');}catch{}
      })().catch(()=>{}).finally(()=>{running=null;});
      return running;
    }
    // Watch cart writes from any script (cart drawer, picker, product forms).
    win.fetch=function(input,init){
      const p=realFetch(input,init);
      try{const url=typeof input==='string'?input:input?.url;if(isCartWrite(url))p.then(r=>{if(r.ok)setTimeout(sync,400);}).catch(()=>{});}catch{}
      return p;
    };
    win.addEventListener('storage',e=>{if(e.key==='bg-cart-updated')sync();});
    // A cart that already has items (form post, cart permalink, earlier page) gets written on load.
    const fresh=/[?&](utm_|ref=|referral_code=|lm=)/.test(win.location.search);
    let synced=false;try{synced=win.sessionStorage.getItem(SYNC_KEY)==='1';}catch{}
    if(synced&&!fresh)return;
    const start=()=>setTimeout(sync,1500);
    if(win.document.readyState==='complete')start();else win.addEventListener('load',start);
  }
  return {KEY,LM_KEY,capture,lmRecord,viewBeacon,analyticsAllowed,cartUpdate,isCartWrite,boot};
});
